module.exports = __webpack_public_path__ + "static/img/open.a033d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/open.png
// module id = lT1v
// module chunks = 216